import { render, staticRenderFns } from "./GenericNav.vue?vue&type=template&id=8b9a41e8&scoped=true&lang=true"
import script from "./GenericNav.vue?vue&type=script&lang=ts"
export * from "./GenericNav.vue?vue&type=script&lang=ts"
import style0 from "./GenericNav.vue?vue&type=style&index=0&id=8b9a41e8&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b9a41e8",
  null
  
)

export default component.exports